var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[(_vm.theme?.product_display == 'grid')?_c('product-grid-card'):_vm._e(),(_vm.theme?.product_display == 'list')?_c('product-list-card'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }